export default "__VITE_ASSET__BcDE63q___"